import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  checkUserAuthentication,
  isExternalUser,
  isInternalUser,
  isAuthInProgress,
  isLogoutInProgress
} from '../utils/authUtils';

export const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if logout is in progress
    if (isLogoutInProgress()) {
      console.log('Logout in progress, not redirecting');
      return;
    }

    // Don't redirect if currently on the sign-in page and auth is in progress
    if (location.pathname === '/' && isAuthInProgress()) {
      console.log('Authentication in progress, waiting...');
      return;
    }

    // Check authentication and redirect accordingly
    if (checkUserAuthentication()) {
      if (isExternalUser()) {
        if (location.pathname !== '/external-home') {
          navigate('/external-home');
        }
      } else if (isInternalUser()) {
        if (location.pathname !== '/internal-home') {
          navigate('/internal-home');
        }
      }
    } else {
      // Only redirect to sign-in if not already there and not in auth process
      if (location.pathname !== '/' && !isAuthInProgress()) {
        navigate('/');
      }
    }
  }, [navigate, location.pathname]);

  return {
    isAuthenticated: checkUserAuthentication(),
    isExternal: isExternalUser(),
    isInternal: isInternalUser(),
    isAuthenticating: isAuthInProgress()
  };
};